<template>
	<div class="wrapper">
		<!-- :list="" -->
		<tag-list-unfold
			:key="tabItem.category + tabItem.name + curIndex+Number(isActivate)"
			v-if="tabItem.subCat == 1"
			:list="categories"
			:elId="curIndex"
			@handleChildPathSelect="getList"
		/>
		<good-card
			v-for="(item, index) of list"
			:class="{ isLast: index === list.length - 1 }"
			@click.native="$sys.dict.href(`product://pid=${item.product_id}`)"
			:key="index"
			:goodItem="item"
		/>
		<!-- list:{{ JSON.stringify(list) }} / pageSize {{ this.pagesize }} -->
		<!-- <div v-if="isShowMoreBtn" class="bottom-btn-wrap"> -->
		<!-- NOTE 查看更多的逻辑？ -->
		<!-- <div class="more-btn" @click="getNextPage">查看更多</div> -->
		<!-- </div> -->
	</div>
</template>

<script>
import tagListUnfold from "./tag-list-unfold.vue";
import goodCard from "./good-card.vue";
export default {
	name: "goodList",
	components: {
		tagListUnfold,
		goodCard,
	},
	props: {
		curIndex: {
			type: Number,
			default: 0,
		},
		tabItem: {
			type: Object,
			default: () => ({}),
		},
		pagesize: {
			type: [Number, String],
			default: 30,
		},
		isActivate: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isShowMoreBtn: true,
			page: 1,
			// pagesize: 30,
			list: [],
			categories: [],
		};
	},
	watch: {
		isActivate: {
			handler(val) {
				if (val) {
					console.log(
						"good-list-activate",
						val,
						this.tabItem.category,
						"subCat",
						this.tabItem.subCat,
					);
					// 判断是否有子分类
					if (this.tabItem.subCat == 1) {
						this.getSubTabData(this.tabItem.catPath);
						this.getList(this.tabItem.catPath);
					} else {
						this.getList(this.tabItem.catPath);
					}
				}
			},
			immediate: true, // 立即监听
		},
	},
	mounted() {
		console.log("-good-list-", this.tabItem.subCat);
		// this.getList();
	},
	methods: {
		getNextPage() {
			this.page++;
			this.getList();
		},
		async getList(catPath) {
			console.log("当前的catPath", catPath);
			try {
				console.log(
					"tabItem",
					this.tabItem.btongBang,
					this.tabItem.name,
					this.tabItem.category,
					this.tabItem.catPath,
					this.tabItem.bangTimeInterval,
					this.page,
					this.pagesize,
				);
				let action = this.tabItem.btongBang ? "bang_tongshu" : "bang_tushu";
				let url = this.tabItem.btongBang ? "/mapi/bang_tongshu" : "/mapi/bang_tushu";
				const res = await this.$axios.get(url, {
					params: {
						action, // bang_tongshu bang_tushu
						// tab_cate: this.tabItem.category,
						price_region: 0,
						// ischildren: 0,
						// 一级传一级的catPath 二级传二级的catPath
						cat_path: catPath,
						bang_name: this.tabItem.category,
						time_region: this.tabItem.bangTimeInterval,
						// img_size: "b",
						page: this.page,
						pagesize: this.pagesize,
					},
				});
				console.log("good-list-res", res);
				this.list = res.products;
				// if (res) {
				// 	this.list = this.list.concat(res.products);
				// }
			} catch (error) {
				console.error("good-list-error", error);
			}
		},
		// 获取子分类tab数据
		async getSubTabData(cid = "") {
			try {
				if (!cid) {
					this.cateTabData = [];
					return;
				}
				const res = await this.$axios.get("/mapi/list_category", {
					params: {
						action: "list_category",
						cid: cid,
					},
				});
				console.log("获取子分类catPath汇总，getSubTabData-res", res);
				// CatID: "16816"
				// CatPath: "01.03.30.00.00.00"
				// ClassCode: "-1805-11656-16816"
				// Count: "229737"
				// ID: "01.03.30.00.00.00"
				// Name: "中国当代小说"
				this.categories = [
					{ Name: "总榜", CatPath: this.tabItem.category },
					...res.categories,
				];
			} catch (error) {
				console.error("getSubTabData-error", error);
				this.$toast("获取子分类失败");
			}
		},
	},
};
</script>

<style lang="less" scoped>
.wrapper {
	// overflow: hidden;
	.isLast {
		border-radius: 0 0 16px 16px;
	}
}
.bottom-btn-wrap {
	margin-top: 20px;
	margin-bottom: 20px;
	text-align: center;
}
.more-btn {
	display: inline-flex;
	width: 156px;
	height: 60px;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 24px;
	border: 0.5px solid #ffffff;
	border-radius: 30px;
	cursor: pointer;
	user-select: none;
}
</style>
